export const GET_OFFER_LOCATIONS = 'GET_OFFER_LOCATIONS';
export const GET_OFFER_INDUSTRIES = 'GET_OFFER_INDUSTRIES';
export const GET_OFFER_METRICS = 'GET_OFFER_METRICS';
export const GET_OFFER_BRANDS = 'GET_OFFER_BRANDS';

export const GET_OFFER_LOCATIONS_SUCCESS = 'GET_OFFER_LOCATIONS_SUCCESS';
export const GET_OFFER_INDUSTRIES_SUCCESS = 'GET_OFFER_INDUSTRIES_SUCCESS';
export const GET_OFFER_METRICS_SUCCESS = 'GET_OFFER_METRICS_SUCCESS';
export const GET_OFFER_BRANDS_SUCCESS = 'GET_OFFER_BRANDS_SUCCESS';
